const assets = {
  _conditional: (data) => {
    const { format, apiData } = data;

    const dynamic = _.get(apiData, "data.dynamic");
    const side = _.get(dynamic, "teamSide");

    let mainVideoBg = null;

    if (format === "1920x1080") {
      mainVideoBg = `mainbackground_1920_${side}`;
    }

    if (format === "1200x1500") {
      mainVideoBg = `mainbackground_1200_${side}`;
    }

    if (format === "1080x1920") {
      mainVideoBg = `mainbackground_1080_${side}`;
    }

    return [assets[mainVideoBg], assets.sap_presents, assets.penny_del];
  },
  mainbackground_1920_home: require("./videos/Background_09_STATS_TEAM_Home_16-9.webm"),
  mainbackground_1920_away: require("./videos/Background_09_STATS_TEAM_Away_16-9.webm"),
  mainbackground_1200_home: require("./images/Background_09_STATS_TEAM_HOME_4-5.png"),
  mainbackground_1200_away: require("./images/Background_09_STATS_TEAM_AWAY_4-5.png"),
  mainbackground_1080_home: require("./images/Background_09_STATS_TEAM_HOME_9-16.png"),
  mainbackground_1080_away: require("./images/Background_09_STATS_TEAM_AWAY_9-16.png"),
  sap_presents: require("../../../assets/logos/sap_white.png"),
  penny_del: require("../../../assets/logos/penny-del-logo-season.png"),
};

export default assets;
